import { motion } from "framer-motion";

export default function Hero({ onStart }) {
  return (
    <section className="weave-grain" data-testid="hero-section">
      <div className="max-w-3xl mx-auto px-6 pt-20 md:pt-28 pb-20">
        <motion.div
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <h1
            className="font-light text-slate-800 leading-[1.02] tracking-tight text-5xl sm:text-6xl lg:text-7xl"
            data-testid="hero-headline"
          >
            Stay <span className="weave-underline">AWAKE</span>
          </h1>

          <p
            className="mt-8 text-xl md:text-2xl font-light text-slate-600 leading-relaxed max-w-2xl"
            data-testid="hero-subtext"
          >
            Turn uncertainty into a clear 90-day plan.
          </p>

          <div
            className="mt-10 rounded-2xl border border-slate-200/70 bg-white/60 backdrop-blur-sm px-6 py-5 md:px-7 md:py-6 max-w-2xl"
            data-testid="hero-what-is-awake"
          >
            <p className="text-base md:text-lg text-slate-700 leading-relaxed">
              <span className="font-medium text-slate-800">
                Stay AWAKE is a thinking tool for founders.
              </span>{" "}
              You feed it what's on your mind — the idea, the blocker, the
              noise — and it walks you through five steps:{" "}
              <span className="text-slate-800">
                <span style={{ color: "#4aa0a4", fontWeight: 500 }}>A</span>
                ttention{" "}
                <span className="text-slate-400">(what matters now)</span> →{" "}
                <span style={{ color: "#f4b847", fontWeight: 500 }}>W</span>
                itness{" "}
                <span className="text-slate-400">(what's really true)</span> →{" "}
                <span style={{ color: "#4aa0a4", fontWeight: 500 }}>A</span>
                lign{" "}
                <span className="text-slate-400">(what only you can do)</span>{" "}
                →{" "}
                <span style={{ color: "#e93e36", fontWeight: 500 }}>K</span>
                ata{" "}
                <span className="text-slate-400">(the daily practice)</span> →{" "}
                <span style={{ color: "#4aa0a4", fontWeight: 500 }}>E</span>
                volve{" "}
                <span className="text-slate-400">
                  (what changes after 90 days)
                </span>
                .
              </span>{" "}
              You leave with a plan you can print, not another dashboard to log
              into.
            </p>
          </div>

          <div className="mt-12 flex flex-wrap items-center gap-4">
            <button
              type="button"
              onClick={onStart}
              className="weave-btn-primary"
              data-testid="hero-start-btn"
            >
              Start your AWAKE journey
            </button>
            <span className="text-sm text-slate-400">
              · 5 steps · about 15 minutes
            </span>
          </div>
        </motion.div>
      </div>

      <div className="weave-thin-rule h-px max-w-3xl mx-auto" />
    </section>
  );
}
